import React from "react";
import cn from "classnames";
import { Box, Button, ButtonProps, Card, Icon, Image, Link, TextSpacing } from "@telia/teddy";
import { Variant } from "@telia/teddy/dist/components/card/utils";
import { Layout } from "@telia/teddy/dist/components/card/card";
import { FlashText as FlashTextModel } from "../../../../../../models";
import FlashText from "../FlashText/FlashText";
import "./ContentBlock.less";

interface ImageType {
    title: string;
    url: string;
}

type ContentBlockProps = {
    badge?: FlashTextModel;
    buttons?: {
        id: string;
        kind: ButtonProps["variant"] | "link";
        text: string;
        url: string;
    }[];
    image: ImageType;
    layout?: Layout;
    text: string;
    title: string;
    titleTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    variant?: Variant;
};

const ContentBlock: React.FC<ContentBlockProps> = ({
    image,
    title,
    titleTag = "h2",
    text,
    buttons,
    badge,
    variant = "gray",
    layout = "rich-card-large",
}) => {
    return (
        <Card
            className={cn("content-block", {
                "content-block__image-vertical": layout === "rich-card",
            })}
            layout={layout}
            variant={variant}
        >
            <Card.Illustration className="content-block__image" inset="all">
                <Image src={image.url} alt={image.title} loading="lazy" />
            </Card.Illustration>
            {badge && (
                <Card.Slot>
                    <FlashText color={badge.color} textColor={badge.textColor} name={badge.text} />
                </Card.Slot>
            )}
            <Card.Content>
                <Card.Heading as={titleTag}>{title}</Card.Heading>
                <TextSpacing>
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                </TextSpacing>
                {buttons && (
                    <div className="content-block__buttons-container">
                        {buttons.map((button) => {
                            if (button.kind === "link") {
                                return (
                                    <Box key={button.id} mt="200">
                                        <Link href={button.url} variant="text">
                                            {button.text}
                                            <Icon name="arrow-right" aria-hidden="true" focusable="false" />
                                        </Link>
                                    </Box>
                                );
                            }
                            return (
                                <Button
                                    onClick={() => {
                                        if (button.url) {
                                            window.location.assign(button.url);
                                        }
                                    }}
                                    className="content-block__buttons"
                                    key={button.id}
                                    variant={button.kind}
                                >
                                    <span>{button.text}</span>{" "}
                                    <Icon name="arrow-right" aria-hidden="true" focusable="false" />
                                </Button>
                            );
                        })}
                    </div>
                )}
            </Card.Content>
        </Card>
    );
};

export default ContentBlock;
